import { API } from '@/api/api';
import type { RequestParams } from '~/interfaces/api';
import type { PostBodyFilters } from '~/interfaces/app';
import { useGlobalStore } from '~/stores/global';

export async function getCategoryData<T>(
  url: string,
  params: RequestParams
): Promise<T | null> {
  const controller = new AbortController();
  if (!import.meta.env.SSR) {
    const globalStore = useGlobalStore();
    globalStore.setCancelToken(controller);
  }
  const res = await API.get(url, { ...params, signal: controller.signal })
    .then((data) => data)
    .catch(() => {
      return null;
    });
  return res?.data;
}

export async function getAnyPostData<T>(
  url: string,
  reqBody: PostBodyFilters | null = null,
  params: RequestParams,
  throwErr = false
): Promise<T | null> {
  try {
    const res = await API.post(url, reqBody, params);
    return res?.data;
  } catch (err: ErrorEvent | any) {
    if (throwErr) throw showError({ statusCode: err.response.status });
    return null;
  }
}

export async function getAnyPostDataDebug<T>(
  url: string,
  reqBody: PostBodyFilters | null = null,
  params: RequestParams,
  throwErr = false
): Promise<T | null> {
  try {
    const res = await API.post(url, reqBody, params);
    return res?.data;
  } catch (err: ErrorEvent | any) {
    if (throwErr) throw showError({ statusCode: err.response.status });
    return null;
  }
}
